import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PeriodoService {
  private readonly path = '';

  constructor(private apiService: ApiService) {}

  // List all periodos
  list(params?: any): Observable<any[]> {
    return this.apiService.get<{ data: any[] }>(`getAllPeriodo`, params).pipe(
      map(response => response.data)
    );
  }

  // Get periodo by ID
  show(id: string): Observable<any> {
    return this.apiService.get<{ object: any }>(`getPeriodoById/${id}`).pipe(
      map(response => response.object)
    );
  }

  // Create new periodo
  store(periodo: any): Observable<any> {
    return this.apiService.post<{ object: any }>(`AddPeriodo`, periodo).pipe(
      map(response => response.object)
    );
  }

  // Update existing periodo
  update(periodo: any): Observable<any> {
    return this.apiService.put<{ object: any }>(`UpdatePeriodo`, periodo).pipe(
      map(response => response.object)
    );
  }

  // Delete periodo by ID
  delete(id: string): Observable<any> {
    return this.apiService.delete(`DeletePeriodoById/${id}`);
  }
}
